import React, { useState, useEffect } from 'react';
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine';
import {
  Container,
  CheckPicker,
  Breadcrumb,
  Button,
  Divider,
  Table,
  Uploader,
  Message,
  Loader,
  Col,
  useToaster,
  Stack,
  Steps,
  Drawer,
  CheckboxGroup,
  Checkbox,
  TagPicker,
  Panel,
  FlexboxGrid,
  Form,
  ButtonToolbar,
  Input,
  InputGroup,
  InputNumber,
  Nav, SelectPicker, InputPicker,
  IconButton,
  ButtonGroup,
  Toggle,
  Grid,
  Row
} from 'rsuite';
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro';
import { Icon } from '@rsuite/icons';
import TrashIcon from '@rsuite/icons/Trash';
import PlusIcon from '@rsuite/icons/Plus';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import { mockUsers } from '../../../data/mock';
import FormGroup from 'rsuite/esm/FormGroup';


const Navbar = ({ active, onSelect, ...props }) => {
  return (
    <Nav {...props} activeKey={active} onSelect={onSelect}>
      <Nav.Item eventKey="home" className='links' href='#1'>
        Basic Details
      </Nav.Item>
      <Nav.Item eventKey="news" className='links' href='#2'>Product Information</Nav.Item>
      <Nav.Item eventKey="solutions" className='links' href='#3'>Internal Details</Nav.Item>
      <Nav.Item eventKey="products" className='links' href='#4'>Production Details</Nav.Item>
    </Nav>
  );
};



const size = [
  { label: 'CM', value: 'cm' },
  { label: 'Inch', value: 'inch' }
];
const cartontype = [
  { label: 'Master', value: 'master' },
  { label: 'Inner', value: 'inner' }
];


const { Column, HeaderCell, Cell } = Table;
const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
const defaultColumns = [
  {
    key: 'id',
    label: 'Id',
    fixed: true,
    width: 70
  },
  {
    key: 'Pcode',
    label: 'Product Code',
    fixed: true,
    width: 130
  },
  {
    key: 'ProductType',
    label: 'Product Type',
    width: 130
  },
  {
    key: 'category',
    label: 'Carton Type',
    width: 123
  },
  {
    key: 'unit',
    label: 'Size Unit',
    width: 123
  },
  {
    key: 'length',
    label: 'Length',
    width: 123
  },

  {
    key: 'width',
    label: 'Width',
    width: 123
  },
  {
    key: 'height',
    label: 'Height',
    width: 123
  },
  {
    key: 'Color',
    label: 'Color',
    width: 123
  },
  {
    key: 'Finish',
    label: 'Finish',
    width: 123
  },
  {
    key: 'Description',
    label: 'Description',
    width: 123
  },
  {
    key: 'Buyer',
    label: 'Buyer',
    width: 123
  },

  {
    key: 'pcscarton',
    label: 'PCS/Carton',
    width: 123
  },
  {
    key: 'CBM',
    label: 'CBM',
    width: 200
  },
];

const defaultData = mockUsers(8);


const EditableCell = ({ rowData, dataKey, onChange, ...props }) => {
  const editing = rowData.status === 'EDIT';
  if (dataKey === "ProductType" || dataKey === "category" || dataKey === "unit" || dataKey === "Color" || dataKey === "Finish" || dataKey === "Buyer") {
    return (
      <Cell {...props} className={editing ? "table-content-editing" : ""}>
        {editing ? (
          <SelectPicker
            defaultValue={rowData[dataKey]}
            onChange={event => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }} data={[]} />
        ) : (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        )}
      </Cell>
    );
  } else if (dataKey === "CBM" || dataKey === "id") {
    return (
      <Cell {...props} className={editing ? "table-content-editing" : ""}>
        {editing ? (
          <input
            className="rs-input"
            readOnly
            defaultValue={rowData[dataKey]}
            onChange={(event) => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }}
          />
        ) : (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        )}
      </Cell>
    );

  } else {
    return (
      <Cell {...props} className={editing ? "table-content-editing" : ""}>
        {editing ? (
          <input
            className="rs-input"
            defaultValue={rowData[dataKey]}
            onChange={(event) => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }}
          />
        ) : (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        )}
      </Cell>
    );

  }
}
const ActionCell = ({ rowData, dataKey, onClick, ...props }) => {
  return (
    <Cell {...props} style={{ padding: '6px' }}>
      <Button
        onClick={() => {
          onClick(rowData.id);
        }}
      >
        {rowData.status === 'EDIT' ? <Icon as={CheckIcon} /> : <Icon as={EditIcon} />}
      </Button>
    </Cell>
  );
};

function previewFile(file, callback) {
  const reader = new FileReader();
  reader.onloadend = () => {
    callback(reader.result);
  };
  reader.readAsDataURL(file);
};

let categoryCodeCounter = 1;
const Addprduct = () => {
  const ip = 'http://192.168.1.23:1337';
  const [showInputs, setShowInputs] = useState(false);
  // //  Rakesh code start
  // const [serviceList, setServiceList] = useState([
  //   { CartonType: "", SizeUnit: "", Length: "", Width: "", Height: "", BoxArea: "", PCS: "", CBM: "", BoxWt: "" }
  // ]);
  // // console.log(serviceList);
  // const handleServiceAdd = () => {
  //   setServiceList([...serviceList, { CartonType: "", SizeUnit: "", Length: "", Width: "", Height: "", BoxArea: "", PCS: "", CBM: "", BoxWt: "" }]);
  // };
  // const handleServiceRemove = (index) => {
  //   const list = [...serviceList];
  //   list.splice(index, 1);
  //   setServiceList(list);
  // };
  // const handleOnChange = (event, index) => {
  //   const { name, value } = event.target;
  //   const list = [...serviceList];
  //   list[index][name] = value;
  //   setServiceList(list);
  // };
  // // Rakesh code end

  const [active, setActive] = React.useState('home');
  const [compact, setCompact] = React.useState(false);
  const [noData, setNoData] = React.useState(false);
  const [autoHeight, setAutoHeight] = React.useState(false);
  const [columnKeys, setColumnKeys] = React.useState(defaultColumns.map(column => column.key));
  const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));
  const CustomCell = compact ? CompactCell : Cell;
  const CustomHeaderCell = compact ? CompactHeaderCell : HeaderCell;
  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState(defaultData);
  const handleEditState = id => {
    const nextData = Object.assign([], data);
    const activeItem = nextData.find(item => item.id === id);
    activeItem.status = activeItem.status ? null : 'EDIT';
    setData(nextData);
  };

  // add number start
  const [len, setLen] = useState(null);
  const [wid, setWid] = useState(null);
  const [hei, setHei] = useState(null);
  const [result, setResult] = useState<any | null>(null);



  // add number end
  const toaster = useToaster();
  const [uploading, setUploading] = React.useState(false);
  const [fileInfo, setFileInfo] = React.useState(null);
  const [showtab, setShowtab] = useState(1);
  const handletab = (e) => {
    setShowtab(e);
  }
  const previous = () => {
    if (showtab == 2) {
      setShowtab(1)
    };
    if (showtab == 3) {
      setShowtab(2)
    };
  };
  const next = () => {
    if (showtab == 1) {
      setShowtab(2)
    };
    if (showtab == 2) {
      setShowtab(3)
    };
    if (showtab == 2) {
    };
  };
  const tableset = () => {
    setOpen(false);
    setData(mockUsers(value));
  };
  const [value, setValue] = React.useState(null);
  // stap code start
  const [step, setStep] = React.useState(0);
  const onChange = (nextStep) => {
    setStep(nextStep < 0 ? 0 : nextStep > 2 ? 2 : nextStep);
  };
  const onNext = () => {
    if (step === 2) {
      document.getElementById("first").style.display = "block";
      document.getElementById("second").style.display = "none";
      document.getElementById("third").style.display = "none";
    } else if (step === 0) {
      document.getElementById("first").style.display = "none";
      document.getElementById("second").style.display = "block";
      document.getElementById("third").style.display = "none";
    } else {
      document.getElementById("first").style.display = "none";
      document.getElementById("second").style.display = "none";
      document.getElementById("third").style.display = "block";
    }
    onChange(step + 1);
  };
  const onPrevious = () => {
    onChange(step - 1);
    if (step === 2) {
      document.getElementById("first").style.display = "none";
      document.getElementById("second").style.display = "block";
      document.getElementById("third").style.display = "none";
    } else if (step === 1) {
      document.getElementById("first").style.display = "block";
      document.getElementById("second").style.display = "none";
      document.getElementById("third").style.display = "none";
    }
  };
  // stap code end
  const [data5, setData5] = useState({
    CategoryCode: "",
    ProductTypeCode: "",
    ProductCode: "",
    ProductId: "",
    ProductName: "",
    Description: "",
    SizeUnit: "inch",
    Length: 0,
    Width: 0,
    Height: 0,
    FinishCode: "",
    ColorCode: "",
    NetWeight: 0,
    GrossWeight: 0,
    HSNCode: "",
    SellingPriceCurrency: "",
    SellingPriceUnit: "",
    SellingPrice: 0,
    ProductCost: 0,
    SearchKeyword: "",
    MOQ: "",
    ProductDesigner: "",
    MadeBy: "",
    CategoryName: "",
    ProductTypeName: "",
    cbm: 0,
    FinishName: "",
    ColorName: "",
    BuyerName: "",
    BuyerSku: "",
    MaterialCollection: [
      {
        ProductCode: "",
        MatCollectionNm: "",
        MatCollectionCode: ""
      }
    ],
    ProductionDetail: [
      {
        ProductCode: "",
        MaterialNm: "",
        MaterialFinishNm: "",
        MatNetWeight: 0,
        MaterialCode: "",
        MaterialFinishCode: ""
      }
    ],
    CoverImage: null,
    MultipleImage: null,
    Total_CBM: null,
    Total_CFT: null,
    TwentyFT: null,
    FortyFT: null,
    FortyHQ: null,
    Packaging: [
      {

        CartonType: "",
        ProductCode: "",
        Carton_Unit: "inch",
        Carton_Length: 0,
        Carton_Width: 0,
        Carton_Thick: 0,
        Carton_CBM: 0,
        Carton_PCS: 0,
        Carton_CBMperpc: 0,
        Carton_GrsWt: 0
      }
    ]
  });

  const [siii, setSiii] = useState(
    [
      { label: 'CM', value: 'cm' },
      { label: 'Inch', value: 'inch' }
    ]
  )



  //////// product fetch start ////////
  const [productdata, setProductdata] = React.useState([]);
  useEffect(() => {
    fetchData0();
  }, []);
  const fetchData0 = async () => {
    const response = await fetch(`${ip}/api/products?populate=*`);
    const json = await response.json();
    setProductdata(json.data);
  };
  const generateNextCategoryCode = () => {
    const categoryCount = productdata.length;
    const nextCode = categoryCount + 1;
    return `PRD-${nextCode.toString().padStart(3, "0")}`;
  };
  const generateNextCollectionCode = (index) => {
    const collectionCount = index + 1;
    return `MCL-${collectionCount.toString().padStart(3, "0")}`;
  };
  const generateNextMaterialCode = index => {
    const materialCount = index + 1;
    return `MTR-${materialCount.toString().padStart(3, "0")}`;
  };

  const generateNextMaterialFinishCode = index => {
    const materialFinishCount = index + 1;
    return `MTRF-${materialFinishCount.toString().padStart(3, "0")}`;
  };
  const addMaterial = () => {
    setData5(prevData => {
      const materialIndex = prevData.ProductionDetail.length;

      // Generate unique codes for the new material
      const newMaterialCode = generateNextMaterialCode(materialIndex);
      const newMaterialFinishCode = generateNextMaterialFinishCode(materialIndex);

      // Assign the codes to the previous material if it exists
      const updatedMaterials = prevData.ProductionDetail.map((material, index) => {
        if (index === materialIndex - 1) {
          return {
            ...material,
            MaterialCode: material.MaterialCode || generateNextMaterialCode(index),
            MaterialFinishCode: material.MaterialFinishCode || generateNextMaterialFinishCode(index)
          };
        }
        return material;
      });

      // Create a new material with codes
      const newMaterial = {
        ProductCode: generateNextCategoryCode(),
        MaterialNm: "",
        MaterialFinishNm: "",
        MatNetWeight: 0,
        MaterialCode: newMaterialCode,
        MaterialFinishCode: newMaterialFinishCode
      };

      return {
        ...prevData,
        ProductionDetail: [...updatedMaterials, newMaterial]
      };
    });
  };


  const addPackaging = () => {
    setData5((prevData) => {
      const newPackaging = {
        CartonType: "",
        ProductCode: generateNextCategoryCode(),
        Carton_Unit: "",
        Carton_Length: 0,
        Carton_Width: 0,
        Carton_Thick: 0,
        Carton_CBM: 0,
        Carton_PCS: 0,
        Carton_CBMperpc: 0,
        Carton_GrsWt: 0,
      };

      return {
        ...prevData,
        Packaging: [...prevData.Packaging, newPackaging],
      };
    });
  };

  const [cbmstate, setCbmstate] = useState(null);
  const [totalcbm1, setTotalCbm] = useState(null);
  const [totalcft, setTotalCFT] = useState(null);
  const [feet20, setFeet20] = useState<any | null>(null);
  const [feet40, setFeet40] = useState<any | null>(null);
  const [feet20hc, setFeet20hc] = useState<any | null>(null);





  const handleInputChange = (inputName, event, index) => {
    const value = event.target ? event.target.value : event;
    if (inputName === "MaterialCollection") {
      const selectedCollections = value.map((collection, i) => ({
        ProductCode: generateNextCategoryCode(),
        MatCollectionNm: collection.label,
        MatCollectionCode: generateNextCollectionCode(i),
      }));

      const selectedLabel = value[value.length - 1]?.label;
      setData5(prevData => ({
        ...prevData,
        MaterialCollection: selectedCollections,
        MatCollectionNm: selectedLabel,
      }));
    } else if (inputName === "CategoryName") {
      const selectedCategory = categorydata.find(item => item.label === value);
      setData5(prevData => ({
        ...prevData,
        CategoryName: value,
        CategoryCode: selectedCategory ? selectedCategory.value : "",
      }));
    }
    else if (inputName === "ProductTypeName") {
      const selectedPtype = productypedata.find(item => item.label === value);
      setData5(prevData => ({
        ...prevData,
        ProductTypeName: value,
        ProductTypeCode: selectedPtype ? selectedPtype.value : "",
      }));
    }
    else if (inputName === "ColorName") {
      const selectedColor = colordata.find(item => item.label === value);
      setData5(prevData => ({
        ...prevData,
        ColorName: value,
        ColorCode: selectedColor ? selectedColor.value : "",
      }));
    } else if (inputName === "FinishName") {
      const selectedFinish = finishdata.find(item => item.label === value);
      setData5(prevData => ({
        ...prevData,
        FinishName: value,
        FinishCode: selectedFinish ? selectedFinish.value : "",
      }));
    }
    else if (inputName.startsWith("MaterialNm")) {

      // Handling MaterialNm input change
      const materialIndex = inputName.split("_")[1];
      setData5(prevData => {
        const updatedMaterials = [...prevData.ProductionDetail];
        updatedMaterials[materialIndex].MaterialNm = value;
        return {
          ...prevData,
          ProductionDetail: updatedMaterials
        };
      });
    } else if (inputName.startsWith("MaterialFinishNm")) {
      // Handling MaterialFinishNm input change
      const materialIndex = inputName.split("_")[1];
      setData5(prevData => {
        const updatedMaterials = [...prevData.ProductionDetail];
        updatedMaterials[materialIndex].MaterialFinishNm = value;
        return {
          ...prevData,
          ProductionDetail: updatedMaterials
        };
      });
    } else if (inputName.startsWith("MatNetWeight")) {
      // Handling MatNetWeight input change
      const materialIndex = inputName.split("_")[1];
      setData5(prevData => {
        const updatedMaterials = [...prevData.ProductionDetail];
        updatedMaterials[materialIndex].MatNetWeight = parseFloat(value);
        return {
          ...prevData,
          ProductionDetail: updatedMaterials
        };
      });
    }

    else if (inputName.startsWith("Carton_GrsWt")) {
      // Handling Carton_GrsWt input change
      setData5((prevData) => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_GrsWt = parseFloat(value);
        return {
          ...prevData,
          Packaging: updatedPackaging,
        };
      });

    } else if (inputName === "SizeUnit") {

      setData5(prevData => ({
        ...prevData,
        SizeUnit: value,
      }));

      var unitt = inputName === 'SizeUnit' ? value : (data5.SizeUnit || 0);
      const length = inputName === 'Length' ? value : (data5.Length || 0);
      const width = inputName === 'Width' ? value : (data5.Width || 0);
      const height = inputName === 'Height' ? value : (data5.Height || 0);

      // Convert dimensions to a common unit (e.g., meters)

      var productcbm3 = 0;
      if (unitt === "cm") {
        productcbm3 = (length * width * height) / 1000000;
      } else {
        productcbm3 = (length * width * height) / 61023;;
      }
      setResult((productcbm3).toFixed(4))


      // Calculate CBM

      // setData5(prevData => ({
      //   ...prevData,
      //   SizeUnit: value,
      //   Length: length,
      //   Width: width,
      //   Height: height,
      //   cbm: result.toFixed(2), // Round CBM to 2 decimal places
      // }));
    }
    else if (inputName === "Length") {

      setData5(prevData => ({
        ...prevData,
        Length: value,
      }));

      var unitt = inputName === 'SizeUnit' ? value : (data5.SizeUnit || 0);
      const length = inputName === 'Length' ? value : (data5.Length || 0);
      const width = inputName === 'Width' ? value : (data5.Width || 0);
      const height = inputName === 'Height' ? value : (data5.Height || 0);

      // Convert dimensions to a common unit (e.g., meters)

      var productcbm3 = 0;
      if (unitt === "cm") {
        productcbm3 = (length * width * height) / 1000000;
      } else {
        productcbm3 = (length * width * height) / 61023;;
      }
      setResult((productcbm3).toFixed(4))


      // Calculate CBM

      // setData5(prevData => ({
      //   ...prevData,
      //   SizeUnit: value,
      //   Length: length,
      //   Width: width,
      //   Height: height,
      //   cbm: result.toFixed(2), // Round CBM to 2 decimal places
      // }));
    }
    else if (inputName === "Width") {

      setData5(prevData => ({
        ...prevData,
        Width: value,
      }));

      var unitt = inputName === 'SizeUnit' ? value : (data5.SizeUnit || 0);
      const length = inputName === 'Length' ? value : (data5.Length || 0);
      const width = inputName === 'Width' ? value : (data5.Width || 0);
      const height = inputName === 'Height' ? value : (data5.Height || 0);

      // Convert dimensions to a common unit (e.g., meters)

      var productcbm3 = 0;
      if (unitt === "cm") {
        productcbm3 = (length * width * height) / 1000000;
      } else {
        productcbm3 = (length * width * height) / 61023;;
      }
      setResult((productcbm3).toFixed(4))


      // Calculate CBM

      // setData5(prevData => ({
      //   ...prevData,
      //   SizeUnit: value,
      //   Length: length,
      //   Width: width,
      //   Height: height,
      //   cbm: result.toFixed(2), // Round CBM to 2 decimal places
      // }));
    }
    else if (inputName === "Height") {

      setData5(prevData => ({
        ...prevData,
        Height: value,
      }));

      var unitt = inputName === 'SizeUnit' ? value : (data5.SizeUnit || 0);
      const length = inputName === 'Length' ? value : (data5.Length || 0);
      const width = inputName === 'Width' ? value : (data5.Width || 0);
      const height = inputName === 'Height' ? value : (data5.Height || 0);

      // Convert dimensions to a common unit (e.g., meters)

      var productcbm3 = 0;
      if (unitt === "cm") {
        productcbm3 = (length * width * height) / 1000000;
      } else {
        productcbm3 = (length * width * height) / 61023;;
      }
      setResult((productcbm3).toFixed(4))


      // Calculate CBM

      // setData5(prevData => ({
      //   ...prevData,
      //   SizeUnit: value,
      //   Length: length,
      //   Width: width,
      //   Height: height,
      //   cbm: result.toFixed(2), // Round CBM to 2 decimal places
      // }));
    }



    else {

      setData5({ ...data5, [inputName]: value });
    }
  };
  const handleInputChange1 = (inputName, event, index) => {
    const value = event.target ? event.target.value : event;
    if (inputName.startsWith("CartonType")) {
      // Handling CartonType input change

      var unitlen = 0;
      setData5((prevData) => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].CartonType = value;
        unitlen = (updatedPackaging.length);
        return {
          ...prevData,
          Packaging: updatedPackaging,
        };
      });

      var productcbm = 0;
      // Handling Carton_Width input change
      var len = data5.Packaging[index].Carton_Length;
      var wid = data5.Packaging[index].Carton_Width;
      var thic = data5.Packaging[index].Carton_Thick;
      var unit = data5.Packaging[index].Carton_Unit;
      var pcc = data5.Packaging[index].Carton_PCS;
      if (unit === "cm") {
        productcbm = (len * wid * thic) / 1000000;
      }
      else {
        productcbm = (len * wid * thic) / 61023;
      }
      var prs = productcbm / pcc;
      var totalcbm = 0;
      var productcbm1 = 0;
      for (var x = 0; x < unitlen; x++) {
        // Handling Carton_Width input change
        var len = data5.Packaging[x].Carton_Length;
        var wid = data5.Packaging[x].Carton_Width;
        var thic = data5.Packaging[x].Carton_Thick;
        var unit = data5.Packaging[x].Carton_Unit;
        var cartontype = data5.Packaging[x].CartonType;
        var pcs1 = data5.Packaging[x].Carton_PCS;

        if (unit === "cm") {
          productcbm1 = ((len * wid * thic) / 1000000) / pcs1;

        }
        else {
          productcbm1 = ((len * wid * thic) / 61023) / pcs1;


        }
        if (cartontype === "master") {
          totalcbm = totalcbm + productcbm1;
        }
        setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
        var bb = totalcbm ? totalcbm * 35.3147 : 0;
        setTotalCFT(bb.toFixed(4));
        setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
        setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
        setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
      }
      console.log(totalcbm + "totalcbm");

      setData5(prevData => {
        const updatedMaterials = [...prevData.Packaging];
        updatedMaterials[index].Carton_CBMperpc = Number(productcbm.toFixed(4));;
        return {
          ...prevData,
          Packaging: updatedMaterials
        };
      });
      if (data5.Packaging[index].Carton_PCS == 0) {
        setData5((prevData) => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(productcbm.toFixed(4));;
          return {
            ...prevData,
            Packaging: updatedPackaging,
          };
        });
      } else {

        setData5((prevData) => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(prs.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging,
          };
        });
      }
    } else if (inputName.startsWith("Carton_Unit")) {
      // Handling Carton_Unit input change


      var unitlen = 0;
      setData5((prevData) => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_Unit = value;
        unitlen = (updatedPackaging.length);

        return {
          ...prevData,
          Packaging: updatedPackaging,
        };
      });


      var productcbm = 0;
      // Handling Carton_Width input change
      var len = data5.Packaging[index].Carton_Length;
      var wid = data5.Packaging[index].Carton_Width;
      var thic = data5.Packaging[index].Carton_Thick;
      var unit = data5.Packaging[index].Carton_Unit;
      var pcc = data5.Packaging[index].Carton_PCS;
      if (unit === "cm") {
        productcbm = (len * wid * thic) / 1000000;

      }
      else {
        productcbm = (len * wid * thic) / 61023;

      }
      var prs = productcbm / pcc;


      var totalcbm = 0;
      var productcbm1 = 0;
      for (var x = 0; x < unitlen; x++) {
        // Handling Carton_Width input change
        var len = data5.Packaging[x].Carton_Length;

        var wid = data5.Packaging[x].Carton_Width;
        var thic = data5.Packaging[x].Carton_Thick;
        var unit = data5.Packaging[x].Carton_Unit;
        var cartontype = data5.Packaging[x].CartonType;
        var pcs1 = data5.Packaging[x].Carton_PCS;

        if (unit === "cm") {
          productcbm1 = ((len * wid * thic) / 1000000) / pcs1;

        }
        else {
          productcbm1 = ((len * wid * thic) / 61023) / pcs1;


        }
        if (cartontype === "master") {
          totalcbm = totalcbm + productcbm1;
        }
        setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
        var bb = totalcbm ? totalcbm * 35.3147 : 0;
        setTotalCFT(bb.toFixed(4));
        setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
        setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
        setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
      }
      console.log(totalcbm + "totalcbm");






      setData5(prevData => {
        const updatedMaterials = [...prevData.Packaging];
        updatedMaterials[index].Carton_CBMperpc = Number(productcbm.toFixed(4));;
        return {
          ...prevData,
          Packaging: updatedMaterials
        };
      });
      if (data5.Packaging[index].Carton_PCS == 0) {
        setData5((prevData) => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(productcbm.toFixed(4));;
          return {
            ...prevData,
            Packaging: updatedPackaging,
          };
        });
      } else {

        setData5((prevData) => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(prs.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging,
          };
        });
      }


    }

    else if (inputName.startsWith("Carton_Length")) {
      var unitlen = 0;
      setData5((prevData) => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_Length = value;
        unitlen = (updatedPackaging.length);

        return {
          ...prevData,
          Packaging: updatedPackaging,
        };
      });
      var productcbm = 0;
      // Handling MatNetWeight input change
      const materialIndex = inputName.split("_")[2];
      var len1 = value;
      var wid = data5.Packaging[materialIndex].Carton_Width;
      var thic = data5.Packaging[materialIndex].Carton_Thick;
      var unit = data5.Packaging[materialIndex].Carton_Unit;
      var pcc = data5.Packaging[index].Carton_PCS
      if (unit === "cm") {
        productcbm = (len1 * wid * thic) / 1000000;
      }
      else {
        productcbm = (len1 * wid * thic) / 61023;
      }
      var prs = productcbm / pcc;


      var totalcbm = 0;
      var productcbm1 = 0;
      for (var x = 0; x < unitlen; x++) {
        // Handling Carton_Width input change
        var len = data5.Packaging[x].Carton_Length;

        var wid = data5.Packaging[x].Carton_Width;
        var thic = data5.Packaging[x].Carton_Thick;
        var unit = data5.Packaging[x].Carton_Unit;
        var cartontype = data5.Packaging[x].CartonType;
        var pcs1 = data5.Packaging[x].Carton_PCS;

        if (unit === "cm") {
          productcbm1 = ((len * wid * thic) / 1000000) / pcs1;

        }
        else {
          productcbm1 = ((len * wid * thic) / 61023) / pcs1;


        }
        if (cartontype === "master") {
          totalcbm = totalcbm + productcbm1;
        }
        setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
        var bb = totalcbm ? totalcbm * 35.3147 : 0;
        setTotalCFT(bb.toFixed(4));
        setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
        setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
        setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
      }



      setData5(prevData => {
        const updatedMaterials = [...prevData.Packaging];
        updatedMaterials[materialIndex].Carton_Length = parseFloat(value);

        return {
          ...prevData,
          Packaging: updatedMaterials
        };
      });

      setData5(prevData => {
        const updatedMaterials = [...prevData.Packaging];
        updatedMaterials[materialIndex].Carton_CBMperpc = Number(productcbm.toFixed(4));;

        return {
          ...prevData,
          Packaging: updatedMaterials
        };
      });
      if (data5.Packaging[index].Carton_PCS == 0) {
        setData5((prevData) => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(productcbm.toFixed(4));;
          return {
            ...prevData,
            Packaging: updatedPackaging,
          };
        });
      } else {

        setData5((prevData) => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(prs.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging,
          };
        });
      }


    }
    else if (inputName.startsWith("Carton_Width")) {

      var unitlen = 0;
      setData5((prevData) => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_Width = value;
        unitlen = (updatedPackaging.length);

        return {
          ...prevData,
          Packaging: updatedPackaging,
        };
      });


      var productcbm = 0;
      // Handling Carton_Width input change
      var len = data5.Packaging[index].Carton_Length;
      var wid1 = value;
      var thic = data5.Packaging[index].Carton_Thick;
      var unit = data5.Packaging[index].Carton_Unit;
      var pcc = data5.Packaging[index].Carton_PCS
      if (unit === "cm") {
        productcbm = (len * wid1 * thic) / 1000000;
      }
      else {
        productcbm = (len * wid1 * thic) / 61023;
      }

      var prs = productcbm / pcc;


      var totalcbm = 0;
      var productcbm1 = 0;
      for (var x = 0; x < unitlen; x++) {
        // Handling Carton_Width input change
        var len = data5.Packaging[x].Carton_Length;

        var wid = data5.Packaging[x].Carton_Width;
        var thic = data5.Packaging[x].Carton_Thick;
        var unit = data5.Packaging[x].Carton_Unit;
        var cartontype = data5.Packaging[x].CartonType;
        var pcs1 = data5.Packaging[x].Carton_PCS;

        if (unit === "cm") {
          productcbm1 = ((len * wid * thic) / 1000000) / pcs1;

        }
        else {
          productcbm1 = ((len * wid * thic) / 61023) / pcs1;


        }
        if (cartontype === "master") {
          totalcbm = totalcbm + productcbm1;
        }
        setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
        var bb = totalcbm ? totalcbm * 35.3147 : 0;
        setTotalCFT(bb.toFixed(4));
        setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
        setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
        setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
      }


      setData5((prevData) => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_Width = parseFloat(value);
        return {
          ...prevData,
          Packaging: updatedPackaging,
        };
      });

      setData5(prevData => {
        const updatedMaterials = [...prevData.Packaging];
        updatedMaterials[index].Carton_CBMperpc = Number(productcbm.toFixed(4));;
        return {
          ...prevData,
          Packaging: updatedMaterials
        };
      });
      if (data5.Packaging[index].Carton_PCS == 0) {
        setData5((prevData) => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(productcbm.toFixed(4));;
          return {
            ...prevData,
            Packaging: updatedPackaging,
          };
        });
      } else {

        setData5((prevData) => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(prs.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging,
          };
        });
      }


    } else if (inputName.startsWith("Carton_Thick")) {
      // Handling Carton_Thick input change

      var unitlen = 0;
      setData5((prevData) => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_Thick = value;
        unitlen = (updatedPackaging.length);

        return {
          ...prevData,
          Packaging: updatedPackaging,
        };
      });

      var productcbm = 0;
      var len = data5.Packaging[index].Carton_Length;
      var wid = data5.Packaging[index].Carton_Width;
      var thic1 = value;
      var unit = data5.Packaging[index].Carton_Unit;
      var pcc = data5.Packaging[index].Carton_PCS
      if (unit === "cm") {
        productcbm = (len * wid * thic1) / 1000000;
      }
      else {
        productcbm = (len * wid * thic1) / 61023;
      }

      var prs = productcbm / pcc;


      var totalcbm = 0;
      var productcbm1 = 0;
      for (var x = 0; x < unitlen; x++) {
        // Handling Carton_Width input change
        var len = data5.Packaging[x].Carton_Length;

        var wid = data5.Packaging[x].Carton_Width;
        var thic = data5.Packaging[x].Carton_Thick;
        var unit = data5.Packaging[x].Carton_Unit;
        var cartontype = data5.Packaging[x].CartonType;
        var pcs1 = data5.Packaging[x].Carton_PCS;

        if (unit === "cm") {
          productcbm1 = ((len * wid * thic) / 1000000) / pcs1;

        }
        else {
          productcbm1 = ((len * wid * thic) / 61023) / pcs1;


        }
        if (cartontype === "master") {
          totalcbm = totalcbm + productcbm1;
        }
        setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
        var bb = totalcbm ? totalcbm * 35.3147 : 0;
        setTotalCFT(bb.toFixed(4));
        setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
        setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
        setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
      }



      setData5((prevData) => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_Thick = parseFloat(value);
        return {
          ...prevData,
          Packaging: updatedPackaging,
        };
      });

      setData5(prevData => {
        const updatedMaterials = [...prevData.Packaging];
        updatedMaterials[index].Carton_CBMperpc = Number(productcbm.toFixed(4));
        return {
          ...prevData,
          Packaging: updatedMaterials
        };
      });
      if (data5.Packaging[index].Carton_PCS == 0) {
        setData5((prevData) => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(productcbm.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging,
          };
        });
      } else {

        setData5((prevData) => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(prs.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging,
          };
        });
      }
    } else if (inputName.startsWith("Carton_PCS")) {
      // Handling Carton_PCS input change
      var unitlen = 0;
      setData5((prevData) => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_PCS = value;
        unitlen = (updatedPackaging.length);

        return {
          ...prevData,
          Packaging: updatedPackaging,
        };
      });



      var productcbm = 0;
      var len = data5.Packaging[index].Carton_Length;
      var wid = data5.Packaging[index].Carton_Width;
      var thic = data5.Packaging[index].Carton_Thick;
      var unit = data5.Packaging[index].Carton_Unit;
      var pcc = data5.Packaging[index].Carton_PCS
      if (unit === "cm") {
        productcbm = (len * wid * thic) / 1000000;
      }
      else {
        productcbm = (len * wid * thic) / 61023;
      }

      var prs = productcbm / pcc;


      var totalcbm = 0;
      var productcbm1 = 0;
      for (var x = 0; x < unitlen; x++) {
        // Handling Carton_Width input change
        var len = data5.Packaging[x].Carton_Length;

        var wid = data5.Packaging[x].Carton_Width;
        var thic = data5.Packaging[x].Carton_Thick;
        var unit = data5.Packaging[x].Carton_Unit;
        var cartontype = data5.Packaging[x].CartonType;
        var pcs1 = data5.Packaging[x].Carton_PCS;

        if (unit === "cm") {
          productcbm1 = ((len * wid * thic) / 1000000) / pcs1;

        }
        else {
          productcbm1 = ((len * wid * thic) / 61023) / pcs1;


        }
        if (cartontype === "master") {
          totalcbm = totalcbm + productcbm1;
        }
        setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
        var bb = totalcbm ? totalcbm * 35.3147 : 0;
        setTotalCFT(bb.toFixed(4));
        setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
        setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
        setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
      }


      setData5((prevData) => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_PCS = parseInt(value, 10);
        return {
          ...prevData,
          Packaging: updatedPackaging,
        };
      });
      if (data5.Packaging[index].Carton_PCS == 0) {
        setData5((prevData) => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(productcbm.toFixed(4));;
          return {
            ...prevData,
            Packaging: updatedPackaging,
          };
        });
      } else {

        setData5((prevData) => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(prs.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging,
          };
        });
      }


    }

    else if (inputName.startsWith("Carton_CBM")) {
      // Handling Carton_CBM input change
      setData5((prevData) => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_CBM = parseFloat(value);
        return {
          ...prevData,
          Packaging: updatedPackaging,
        };
      });
    }
    else if (inputName.startsWith("Perpc")) {
      // Handling Carton_CBMperpc input change
      setData5((prevData) => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_CBMperpc = parseFloat(value);
        return {
          ...prevData,
          Packaging: updatedPackaging,
        };
      });
    }


  }


  const deleteMaterial = index => {
    setData5(prevData => {
      const updatedMaterials = [...prevData.ProductionDetail];
      updatedMaterials.splice(index, 1);
      return {
        ...prevData,
        ProductionDetail: updatedMaterials,
      };
    });
  };
  const deletePackege = index => {
    setData5(prevData => {
      const updatedMaterials = [...prevData.Packaging];
      updatedMaterials.splice(index, 1);
      return {
        ...prevData,
        Packaging: updatedMaterials,
      };
    });
  };
  const handleImageUpload = fileList => {
    setData5({
      ...data5,
      CoverImage: fileList[0].blobFile
    });
  };
  const handleImageUpload1 = fileList => {
    setData5({
      ...data5,
      MultipleImage: fileList[0].blobFile
    });
  };
  // Delete Data from API Start
  //////// product fetch start ////////


  const url2 = `${ip}/api/products`;
  const submit = e => {
    if (data5.CategoryCode == '') {
      toaster.push(<Message showIcon type='error' >
        Please add atleast one Product.
      </Message>, { placement: 'topCenter' });
    } else if (data5.CoverImage == null) {
      toaster.push(<Message showIcon type='error' >
        Please add atleast one Product Image.
      </Message>, { placement: 'topCenter' });
    } else {
      e.preventDefault();
      const nextCategoryCode = generateNextCategoryCode();
      const formData = new FormData();
      formData.append('files.CoverImage', data5.CoverImage);
      formData.append('files.MultipleImage', data5.MultipleImage);
      // data5.MultipleImage.forEach((file, index) => {
      //   formData.append(`files.MultipleImage[${index}]`, file.blobFile);
      // });
      data5.MaterialCollection.forEach((collection, index) => {

        formData.append(`data.MaterialCollection[${index + 1}].ProductCode`, nextCategoryCode);
        formData.append(`data.MaterialCollection[${index}].MatCollectionNm`, collection.MatCollectionNm);
        formData.append(`data.MaterialCollection[${index}].MatCollectionCode`, collection.MatCollectionCode);
      });
      if (data5.ProductionDetail.length > 0) {
        data5.ProductionDetail[0].ProductCode = data5.ProductCode;
      }
      data5.ProductionDetail.forEach((material, index) => {
        formData.append(`ProductionDetail[${index + 1}][ProductCode]`, nextCategoryCode);
        formData.append(`ProductionDetail[${index}][MaterialNm]`, material.MaterialNm);
        formData.append(`ProductionDetail[${index}][MaterialFinishNm]`, material.MaterialFinishNm);
        formData.append(`ProductionDetail[${index}][MatNetWeight]`, String(material.MatNetWeight));
        formData.append(`ProductionDetail[${index}][MaterialCode]`, material.MaterialCode);
        formData.append(`ProductionDetail[${index}][MaterialFinishCode]`, material.MaterialFinishCode);
      });

      formData.append("data", JSON.stringify({
        ...data5,
        ProductCode: nextCategoryCode, // Include ColorCode in formData
        Total_CBM: totalcbm1,
        Total_CFT: totalcft,
        TwentyFT: feet20,
        FortyFT: feet40,
        FortyHQ: feet20hc

      }));
      fetch(url2, {
        method: 'POST',
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);
          // Refresh page after 2 seconds (3000 milliseconds)
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch(error => console.error(error));
      categoryCodeCounter++;
      toaster.push(<Message showIcon type='success' >
        Saved Successfully
      </Message>, { placement: 'topCenter' });
    }
  };

  //category data fetch start
  const [categorydata, setCategorydata] = React.useState([]);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const response = await fetch(`${ip}/api/mstcategories`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.CategoryName,
        value: item.attributes.CategoryCode,
      }));
      setCategorydata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  //category data fetch end

  //product type data fetch start
  const [productypedata, setProductypedata] = React.useState([]);
  useEffect(() => {
    fetchData2();
  }, []);
  const fetchData2 = async () => {
    try {
      const response = await fetch(`${ip}/api/mstproducttypes`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.ProductTypeName,
        value: item.attributes.ProductTypeCode,
      }));
      setProductypedata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  //product type data fetch end

  //Collection type data fetch start
  const [collectiondata, setCollectiondata] = React.useState([]);
  useEffect(() => {
    fetchData3();
  }, []);
  const fetchData3 = async () => {
    try {
      const response = await fetch(`${ip}/api/mstmaterialcollections`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.MatCollectionName,
        value: item.attributes.MatCollectionCode,
      }));
      setCollectiondata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  //Collection type data fetch end
  //Finish type data fetch start
  const [finishdata, setFinishdata] = React.useState([]);
  useEffect(() => {
    fetchData4();
  }, []);
  const fetchData4 = async () => {
    try {
      const response = await fetch(`${ip}/api/mstfinishes`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.FinishName,
        value: item.attributes.FinishCode,
      }));
      setFinishdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  //Finish type data fetch end
  //color type data fetch start
  const [colordata, setColordata] = React.useState([]);
  useEffect(() => {
    fetchData5();
  }, []);
  const fetchData5 = async () => {
    try {
      const response = await fetch(`${ip}/api/mstcolors`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.ColorName,
        value: item.attributes.ColorCode,
      }));
      setColordata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  //color type data fetch end
  //hsn type data fetch start
  const [hsndata, setHsndata] = React.useState([]);
  useEffect(() => {
    fetchData6();
  }, []);
  const fetchData6 = async () => {
    try {
      const response = await fetch(`${ip}/api/msthscodes`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.hscode,
        value: item.attributes.hscode,
      }));
      setHsndata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  //hsn type data fetch end
  //material type data fetch start
  const [materialdata, setMaterialdata] = React.useState([]);
  useEffect(() => {
    fetchData7();
  }, []);
  const fetchData7 = async () => {
    try {
      const response = await fetch(`${ip}/api/mstmaterials`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.MaterialName,
        value: item.attributes.MaterialCode,
      }));
      setMaterialdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  //material type data fetch end

  const [buyeerdata, setBuyeerdata] = React.useState([]);
  useEffect(() => {
    fetchDatab();
  }, []);
  const fetchDatab = async () => {
    try {
      const response = await fetch(`${ip}/api/buyer-details`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.buyernm,
        value: item.attributes.buyercode,
      }));
      setBuyeerdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };


  return (
    <>
      <Container className='main table-toolbar'>
        <Panel >
          <h3 className="title">Single Upload</h3>
          <Breadcrumb>
            <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/products">Product</Breadcrumb.Item>
            <Breadcrumb.Item active>Add Product</Breadcrumb.Item>
          </Breadcrumb>
        </Panel>
        <Steps current={step} style={{ width: '56%', marginLeft: '12px' }}>
          <Steps.Item title="Basic Information" />
          <Steps.Item title="Variants" />
          <Steps.Item title="Package Loadability" />
        </Steps>

        <Divider />

        <div id="first">
          <FlexboxGrid justify="space-around">
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <Uploader
                onChange={handleImageUpload}
                fileListVisible={false}
                listType="picture"
                action={""}
                onUpload={file => {
                  setUploading(true);
                  previewFile(file.blobFile, value => {
                    setFileInfo(value);
                  });
                }}
                onSuccess={(response, file) => {
                  setUploading(false);
                  toaster.push(<Message type="success">Uploaded Successfully</Message>);
                  console.log(response);
                }}
                onError={() => {
                  setFileInfo(null);
                  setUploading(false);
                  toaster.push(<Message type="success">Uploaded Successfully</Message>);
                }}
              >
                <button style={{ width: 255, height: 255 }}>
                  {uploading && <Loader backdrop center />}
                  {fileInfo ? (
                    <img src={fileInfo} width="100%" height="100%" />
                  ) : (
                    <CameraRetroIcon style={{ fontSize: 80 }} />
                  )}
                </button>
              </Uploader>
              <Stack wrap>
                <Uploader autoUpload={false}
                  onChange={handleImageUpload1} multiple listType="picture" action={""}>
                  <button>
                    <CameraRetroIcon />
                  </button>
                </Uploader>

              </Stack>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={14}>
              <Navbar appearance="subtle" active={active} onSelect={setActive} />
              <Form className='formScroll' >


                {/* <Uploader multiple
  accept="image/*"
  onChange={files => handleImageUpload(files)}
  action={''}>
                  <button>
                    <CameraRetroIcon />
                  </button>
                </Uploader> */}

                {/* <Uploader
                
                  autoUpload={false}
                  onChange={handleImageUpload}
                  fileListVisible={false} action={''}      >
        <button>Upload File</button>
      </Uploader> */}
                {/* <Uploader autoUpload={false}
                  onChange={handleImageUpload}
                  fileListVisible={false} multiple listType="picture" action="//jsonplaceholder.typicode.com/posts/">
            <button>
              <CameraRetroIcon />
            </button>
          </Uploader> */}

                {/* <input type="file" onChange={e => handleImageUpload(e.target.files[0])} /> */}

                <section id='1' >
                  <Divider ><b>Basic Details</b></Divider>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Category</Form.ControlLabel>
                    <SelectPicker
                      id="CategoryName"
                      name="CategoryName"
                      value={data5.CategoryName || ""}
                      onChange={value => handleInputChange("CategoryName", value, 0)}
                      data={categorydata}
                      placeholder="Select"
                      labelKey="label"
                      valueKey="label"
                      block
                      placement="autoVerticalStart"
                    />
                    {/* <SelectPicker
                      id="CategoryCode"
                      name="CategoryCode"
                      value={data5 && data5.CategoryCode ? data5.CategoryCode : ''}
                      onChange={value => handleInputChange('CategoryCode', value, 0)}
                      data={categorydata}
                      placeholder="Select a category"
                      labelKey="label"
                      valueKey="value"
                      block
                    /> */}
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Product Type</Form.ControlLabel>
                    <SelectPicker
                      id="ProductTypeName"
                      name="ProductTypeName"
                      value={data5.ProductTypeName || ""}
                      onChange={value => handleInputChange("ProductTypeName", value, 0)}
                      data={productypedata}
                      placeholder="Select"
                      labelKey="label"
                      valueKey="label"
                      block
                      placement="autoVerticalStart"
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.ControlLabel>Collection</Form.ControlLabel>
                    {/* <Input id='ProductCode' name="ProductCode" value={data5 && data5.ProductCode ? data5.ProductCode : ''} onChange={value => handleInputChange('ProductCode', value, 0)} /> */}
                    <CheckPicker
                      id="MaterialCollection"
                      name="MaterialCollection"
                      data={collectiondata}
                      value={data5[0]?.MaterialCollection?.map(collection => collection.MatCollectionCode)}
                      onChange={value => handleInputChange("MaterialCollection", value, 0)}
                      placeholder="Select Collection"
                      labelKey="label"
                      valueKey="label"
                      block
                      placement="autoVerticalStart"
                    />
                    {/* <CheckPicker
                      // id="ProductTypeCode"
                      // name="ProductTypeCode"
                      // value={data5 && data5.ProductTypeCode ? data5.ProductTypeCode : ''}
                      // onChange={value => handleInputChange('ProductTypeCode', value, 0)}
                      data={collectiondata}
                      placeholder="Select Collection"
                      labelKey="label"
                      valueKey="value"
                      block
                    /> */}
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Product ID</Form.ControlLabel>
                    <Input id='ProductId' name="ProductId" value={data5 && data5.ProductId ? data5.ProductId : ''} onChange={value => handleInputChange('ProductId', value, 0)} />
                  </Form.Group>
                </section>
                <section id='2'>
                  <Divider ><b>Product Information</b></Divider>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Product Name</Form.ControlLabel>
                    <Input id='ProductName' name="ProductName" value={data5 && data5.ProductName ? data5.ProductName : ''} onChange={value => handleInputChange('ProductName', value, 0)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel >Description</Form.ControlLabel>
                    <Input id='Description' name="Description" value={data5 && data5.Description ? data5.Description : ''} onChange={value => handleInputChange('Description', value, 0)} placeholder="Textarea" />
                  </Form.Group>
                  <FlexboxGrid justify="space-between">
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel >Size</Form.ControlLabel>
                        <InputPicker data={size} id='SizeUnit' name="SizeUnit" value={data5 && data5.SizeUnit ? data5.SizeUnit : 'inch'} onChange={value => handleInputChange('SizeUnit', value, 0)} block />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel >Length</Form.ControlLabel>
                        <InputNumber style={{ width: 'auto' }} id='Length' name="Length" value={data5 && data5.Length ? data5.Length : ''} onChange={value => handleInputChange('Length', value, 0)} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel >Width</Form.ControlLabel>
                        <InputNumber style={{ width: 'auto' }} id='Width' name="Width" value={data5 && data5.Width ? data5.Width : ''} onChange={value => handleInputChange('Width', value, 0)} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel >Height</Form.ControlLabel>
                        <InputNumber style={{ width: 'auto' }} id='Height' name="Height" value={data5 && data5.Height ? data5.Height : ''} onChange={value => handleInputChange('Height', value, 0)} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group" >
                        <Form.ControlLabel >CBM</Form.ControlLabel>
                        <Input readOnly value={result} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel >Finish</Form.ControlLabel>
                    <SelectPicker
                      id="FinishName"
                      name="FinishName"
                      value={data5.FinishName || ""}
                      onChange={value => handleInputChange("FinishName", value, 0)}
                      data={finishdata}
                      placeholder="Select Finish Name"
                      labelKey="label"
                      valueKey="label"
                      block
                      placement="autoVerticalStart"
                    />
                    {/* <Input id='Finish' name="Finish" value={data5 && data5.Finish ? data5.Finish : ''} onChange={value => handleInputChange('Finish', value, 0)} /> */}
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel >Color</Form.ControlLabel>
                    <SelectPicker
                      id="ColorName"
                      name="ColorName"
                      value={data5.ColorName || ""}
                      onChange={value => handleInputChange("ColorName", value, 0)}
                      data={colordata}
                      placeholder="Select Color"
                      labelKey="label"
                      valueKey="label"
                      block
                      placement="autoVerticalStart"
                    />
                    {/* <Input id='Color' name="Color" value={data5 && data5.Color ? data5.Color : ''} onChange={value => handleInputChange('Color', value, 0)} /> */}
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Net Weight (kg.)</Form.ControlLabel>
                    <InputNumber style={{ width: 'auto' }} id='NetWeight' name="NetWeight" value={data5 && data5.NetWeight ? data5.NetWeight : ''} onChange={value => handleInputChange('NetWeight', value, 0)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Gross Weight (kg.)</Form.ControlLabel>
                    <InputNumber style={{ width: 'auto' }} id='GrossWeight' name="GrossWeight" value={data5 && data5.GrossWeight ? data5.GrossWeight : ''} onChange={value => handleInputChange('GrossWeight', value, 0)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>HSN</Form.ControlLabel>
                    <SelectPicker
                      id="HSNCode"
                      name="HSNCode"
                      value={data5 && data5.HSNCode ? data5.HSNCode : ''}
                      onChange={value => handleInputChange('HSNCode', value, 0)}
                      data={hsndata}
                      placeholder="Select HSN"
                      labelKey="label"
                      valueKey="value"
                      block
                      placement="autoVerticalStart"
                    />
                    {/* <Input id='HSNCode' name="HSNCode" value={data5 && data5.HSNCode ? data5.HSNCode : ''} onChange={value => handleInputChange('HSNCode', value, 0)} /> */}
                  </Form.Group>
                  <FlexboxGrid justify="space-between">
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel>Selling Pr. Cur.</Form.ControlLabel>
                        <Input id='SellingPriceCurrency' name="SellingPriceCurrency" value={data5 && data5.SellingPriceCurrency ? data5.SellingPriceCurrency : ''} onChange={value => handleInputChange('SellingPriceCurrency', value, 0)} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={14}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel>Selling Price Unit</Form.ControlLabel>
                        <Input id='SellingPriceUnit' name="SellingPriceUnit" value={data5 && data5.SellingPriceUnit ? data5.SellingPriceUnit : ''} onChange={value => handleInputChange('SellingPriceUnit', value, 0)} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel>Selling Price</Form.ControlLabel>
                        <InputNumber style={{ width: 'auto' }} id='SellingPrice' name="SellingPrice" value={data5 && data5.SellingPrice ? data5.SellingPrice : ''} onChange={value => handleInputChange('SellingPrice', value, 0)} />
                      </Form.Group>
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                </section>
                <section id='3'>
                  <Divider><b>Internal Details</b></Divider>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Product Cost (INR)</Form.ControlLabel>
                    <InputNumber style={{ width: 'auto' }} id='ProductCost' name="ProductCost" value={data5 && data5.ProductCost ? data5.ProductCost : ''} onChange={value => handleInputChange('ProductCost', value, 0)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Search Keyword</Form.ControlLabel>
                    <Input id='SearchKeyword' name="SearchKeyword" value={data5 && data5.SearchKeyword ? data5.SearchKeyword : ''} onChange={value => handleInputChange('SearchKeyword', value, 0)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>MOQ</Form.ControlLabel>
                    <Input id='MOQ' name="MOQ" value={data5 && data5.MOQ ? data5.MOQ : ''} onChange={value => handleInputChange('MOQ', value, 0)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Product Designer</Form.ControlLabel>
                    <Input id='ProductDesigner' name="ProductDesigner" value={data5 && data5.ProductDesigner ? data5.ProductDesigner : ''} onChange={value => handleInputChange('ProductDesigner', value, 0)} />
                  </Form.Group>
                  <Form.Group controlId="input-group">
                    <Form.ControlLabel>Made By</Form.ControlLabel>
                    <Input id='MadeBy' name="MadeBy" value={data5 && data5.MadeBy ? data5.MadeBy : ''} onChange={value => handleInputChange('MadeBy', value, 0)} />
                  </Form.Group>
                  {/* <button type='submit' onClick={submit}> Submit</button> */}
                  <Form.Group controlId="input-group">
                    <Stack spacing={6} justifyContent="space-between">
                      <b>Is this product exclusively made for a buyer ?</b>
                      <Toggle checked={showInputs}
                        onChange={value => setShowInputs(value)} />
                    </Stack>
                    <Stack spacing={6}>
                      Click on the toggle to enter buyer details
                    </Stack>
                  </Form.Group>
                  {showInputs && (
                    <div>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                        <SelectPicker
                          id="BuyerName"
                          name="BuyerName"
                          value={data5.BuyerName || ""}
                          onChange={value => handleInputChange("BuyerName", value, 0)}
                          data={buyeerdata}
                          placeholder="Select Color"
                          labelKey="label"
                          valueKey="label"
                          block
                          placement="autoVerticalStart"
                        />
                      </Form.Group>
                      <Form.Group controlId="input-group">
                        <Form.ControlLabel>Buyer SKU</Form.ControlLabel>
                        <Input id='BuyerSku' name="BuyerSku" value={data5 && data5.BuyerSku ? data5.BuyerSku : ''} onChange={value => handleInputChange('BuyerSku', value, 0)} />
                      </Form.Group>
                    </div>
                  )}
                </section>

                <section id='4'>
                  <Divider><b>Production Details</b></Divider>
                  <Form >
                    {data5.ProductionDetail.map((material, index) => (
                      <div key={index}>
                        <FlexboxGrid justify="space-around" style={{ marginBottom: '12px' }}>
                          <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                            <Form.ControlLabel>Material Name</Form.ControlLabel>
                            <SelectPicker
                              id="MaterialName"
                              name="MaterialName"
                              value={material.MaterialNm}
                              onChange={event => handleInputChange(`MaterialNm_${index}`, event, index)}
                              data={materialdata}
                              placeholder="Select"
                              labelKey="label"
                              valueKey="value"
                              block
                              placement="autoVerticalStart"
                            />
                            {/* <Input
                              name={`MaterialNm_${index}`}
                              value={material.MaterialNm}
                              onChange={event => handleInputChange(`MaterialNm_${index}`, event, index)}
                            /> */}
                          </FlexboxGrid.Item>
                          <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                            <Form.ControlLabel>Material Finish Name</Form.ControlLabel>
                            <SelectPicker
                              id="FinishName"
                              name="FinishName"
                              value={material.MaterialFinishNm}
                              onChange={event => handleInputChange(`MaterialFinishNm_${index}`, event, index)}
                              data={finishdata}
                              placeholder="Select"
                              labelKey="label"
                              valueKey="value"
                              block
                              placement="autoVerticalStart"
                            />
                            {/* <Input
                              name={`MaterialFinishNm_${index}`}
                              value={material.MaterialFinishNm}
                              onChange={event => handleInputChange(`MaterialFinishNm_${index}`, event, index)}
                            /> */}
                          </FlexboxGrid.Item>
                          <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                            <Form.ControlLabel>Material Net Wt.</Form.ControlLabel>
                            <Input
                              name={`MatNetWeight_${index}`}
                              value={material.MatNetWeight}
                              onChange={event => handleInputChange(`MatNetWeight_${index}`, event, index)}
                            />
                          </FlexboxGrid.Item>
                          <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                            {index > 0 && (
                              <IconButton active style={{ marginTop: '20px' }} onClick={() => deleteMaterial(index)} icon={<TrashIcon />} />

                            )}
                          </FlexboxGrid.Item>
                        </FlexboxGrid>
                      </div>
                    ))}
                    <Button active onClick={addMaterial}>Add Row</Button>

                  </Form>

                </section>
              </Form>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </div>
        <div id="second" style={{ display: "none" }}>
          <Panel>
            <ButtonToolbar >
              <IconButton icon={<PlusIcon />} onClick={() => setOpen(true)} >Add Variants</IconButton>
            </ButtonToolbar>
          </Panel>
          <Panel>
            <Table
              height={300}
              data={[]}
            // data={noData ? [] : data}
            >
              {columns.map(column => {
                const { key, label, ...rest } = column;
                return (
                  <Column {...rest} key={key}>
                    <CustomHeaderCell>{label}</CustomHeaderCell>
                    <EditableCell dataKey={key} onChange={undefined} rowData={undefined} />
                  </Column>
                );
              })}
              <Column flexGrow={1}>
                <HeaderCell>Action</HeaderCell>
                <ActionCell dataKey="id" onClick={handleEditState} rowData={undefined} />
              </Column>
            </Table>
          </Panel>
          <Drawer open={open} onClose={() => setOpen(false)}>
            <Drawer.Header>
              <Drawer.Title>Add Variants</Drawer.Title>
              <Drawer.Actions>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
                <Button color="cyan" onClick={tableset} appearance="primary">
                  Confirm
                </Button>
              </Drawer.Actions>
            </Drawer.Header>
            <Drawer.Body>
              <Panel>
                <Stack spacing={100} >
                  Variants:
                  <InputGroup >
                    <InputNumber value={value} onChange={setValue} defaultValue={10} min={1} />
                  </InputGroup>
                </Stack>
              </Panel>
              <Panel>
                <p>Select Attribute</p>
                <TagPicker
                  data={defaultColumns}
                  labelKey="label"
                  valueKey="key"
                  value={columnKeys}
                  onChange={setColumnKeys}
                  cleanable={false}
                />
                <Divider />
                <p>Suggested</p>
                <Stack justifyContent='flex-start' spacing={12}>
                  <CheckboxGroup>
                    <Checkbox value="A">Color</Checkbox>
                    <Checkbox value="K">Metarial</Checkbox>
                    <Checkbox value="C">Size</Checkbox>
                  </CheckboxGroup>

                  <CheckboxGroup>
                    <Checkbox value="D">Finish</Checkbox>
                    <Checkbox value="I">Name</Checkbox>
                    <Checkbox value="J">Vendor Name</Checkbox>
                  </CheckboxGroup>
                </Stack>
              </Panel>
            </Drawer.Body>
          </Drawer>
        </div>
        <div id="third" style={{ display: "none" }}>
          <Panel header="Packaging"  >
            <div>
              <Form fluid>
                {data5.Packaging.map((packaging, index) => (
                  <div key={index}>

                    <FlexboxGrid justify="space-around" style={{ marginBottom: '10px' }}>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>Carton Type</Form.ControlLabel>
                        <InputPicker
                          data={cartontype}
                          name={`CartonType_${index}`}
                          value={packaging.CartonType}
                          onChange={(event) => handleInputChange1(`CartonType_${index}`, event, index)}
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>SizeUnit</Form.ControlLabel>
                        <InputPicker
                          data={siii}
                          name={`Carton_Unit_${index}`}
                          value={packaging.Carton_Unit || 'inch'}
                          onChange={(event) => handleInputChange1(`Carton_Unit_${index}`, event, index)}

                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>Length</Form.ControlLabel>
                        <InputNumber

                          name={`Carton_Length_${index}`}
                          value={packaging.Carton_Length}
                          onChange={(event) => handleInputChange1(`Carton_Length_${index}`, event, index)}
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>Width</Form.ControlLabel>
                        <InputNumber
                          name={`Carton_Width_${index}`}
                          value={packaging.Carton_Width}
                          onChange={(event) => handleInputChange1(`Carton_Width_${index}`, event, index)}

                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>Height</Form.ControlLabel>
                        <InputNumber
                          name={`Carton_Thick_${index}`}
                          value={packaging.Carton_Thick}
                          onChange={(event) => handleInputChange1(`Carton_Thick_${index}`, event, index)}
                        />
                      </FlexboxGrid.Item>

                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>Box Area</Form.ControlLabel>
                        <Input
                          readOnly
                          name={`Perpc_${index}`}
                          value={packaging.Carton_CBMperpc}
                          onChange={(event) => handleInputChange1(`Perpc_${index}`, event, index)}
                        />
                      </FlexboxGrid.Item>


                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>PCS</Form.ControlLabel>
                        <InputNumber
                          min={0}
                          name={`Carton_PCS_${index}`}
                          value={packaging.Carton_PCS}
                          onChange={(event) => handleInputChange1(`Carton_PCS_${index}`, event, index)}
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>CBM</Form.ControlLabel>
                        <Input
                          readOnly
                          name={`Carton_CBM_${index}`}
                          value={packaging.Carton_CBM}
                          onChange={(event) => handleInputChange1(`Carton_CBM_${index}`, event, index)}
                        />
                      </FlexboxGrid.Item>

                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>Gross Wt.</Form.ControlLabel>
                        <InputNumber
                          name={`Carton_GrsWt_${index}`}
                          value={packaging.Carton_GrsWt}
                          onChange={(event) => handleInputChange(`Carton_GrsWt_${index}`, event, index)}
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        {index > 0 && (
                          <IconButton active style={{ marginTop: '20px' }} onClick={() => deletePackege(index)} icon={<TrashIcon />} />
                        )}
                      </FlexboxGrid.Item>

                    </FlexboxGrid>

                  </div>
                ))}
                <Button active onClick={addPackaging}>Add Row</Button>
              </Form>
            </div>
          </Panel>

          <Panel header="Loadability">

            <Form fluid>
              <FlexboxGrid justify="space-between">
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Total CBM</Form.ControlLabel>
                    <InputNumber id='Total_CBM' name="Total_CBM" value={totalcbm1} onChange={value => handleInputChange('Total_CBM', value, 0)} />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Total CFT</Form.ControlLabel>
                    <InputNumber id='Total_CFT' name="Total_CFT" value={totalcft} onChange={value => handleInputChange('Total_CFT', value, 0)} />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>20FT</Form.ControlLabel>
                    <Input id='TwentyFT' name="TwentyFT" value={feet20} onChange={value => handleInputChange('TwentyFT', value, 0)} />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>40FT</Form.ControlLabel>
                    <Input id='FortyFT' name="FortyFT" value={feet40} onChange={value => handleInputChange('FortyFT', value, 0)} />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>40HQ</Form.ControlLabel>
                    <Input id='FortyHQ' name="FortyHQ" value={feet20hc} onChange={value => handleInputChange('FortyHQ', value, 0)} />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>

          </Panel>

        </div>

        <Stack justifyContent="flex-end">
          <Panel>
            <ButtonGroup>
              <Button onClick={onPrevious} disabled={step === 0}>
                Previous
              </Button>
              {step === 2 ? (
                <Button color="cyan" appearance="primary" onClick={submit}>
                  Save
                </Button>
              ) : (
                <Button color="cyan" appearance="primary" onClick={onNext} disabled={step === 2}>
                  Next
                </Button>
              )}
            </ButtonGroup>
            {/* <ButtonGroup>
              <Button onClick={onPrevious} disabled={step === 0}>
                Previous
              </Button>
              <Button color="cyan" appearance='primary' onClick={onNext} disabled={step === 2}>
                Next
              </Button>
            </ButtonGroup> */}
          </Panel>
        </Stack>
        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>
      </Container>

    </>
  );
};

export default Addprduct;